module.exports = __webpack_public_path__ + "img/starbucks1.f5a286e2.png";